import { render, staticRenderFns } from "./PerformanceReportingOverlay.vue?vue&type=template&id=303d45dd&"
import script from "./PerformanceReportingOverlay.vue?vue&type=script&lang=js&"
export * from "./PerformanceReportingOverlay.vue?vue&type=script&lang=js&"
import style0 from "./PerformanceReportingOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports